import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import studioApi from '../../api/studioApi';
import userApi from '../../api/userApi';
import { useParams, useNavigate } from 'react-router-dom';

export default function StudioEditPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [users, setUsers] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    studioApi.get(id).then(r => setForm(r.data));
    userApi.list({ profile: 'STUDIO' }).then(r => setUsers(r.data.content || []));
  }, [id]);

  if (!form) return <div>Loading...</div>;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await studioApi.update(id, form);
      navigate(`/studi/${id}`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
      <Typography variant="h5">Modifica Studio</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField fullWidth sx={{ my: 1 }} label="Ragione Sociale" value={form.ragionesociale} onChange={e => setForm({...form, ragioneSociale: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Codice Fiscale" value={form.codiceFiscale} onChange={e => setForm({...form, codiceFiscale: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }}
        label="Partita IVA"
        value={form.partitaIVA}
        required
        inputProps={{
                maxLength: 11,
                inputMode: "numeric",
                pattern: "[0-9]{11}"
        }}
        onChange={e => setForm({...form, partitaIVA: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Indirizzo" value={form.indirizzo} onChange={e => setForm({...form, indirizzo: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Telefono" value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} />
        <TextField select fullWidth sx={{ my: 1 }} label="Utente" value={form.utenteId} onChange={e => setForm({...form, utenteId: e.target.value})}>
          {users.map(u => <MenuItem key={u.id} value={u.id}>{u.username}</MenuItem>)}
        </TextField>
        <Button variant="contained" type="submit">Salva</Button>
      </form>
    </Container>
  );
}